import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: (() => { try { return localStorage.getItem('erp_last_email') || ''; } catch { return ''; } })(), password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const correo = (form.email || '').trim().toLowerCase();
      try { localStorage.setItem('erp_last_email', correo); } catch {}
      const res = await login(correo, form.password);
      const u = res?.user;
      navigate(u?.es_super_admin && !u?.tenant_id ? '/super-admin' : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.logo}>ERP</div>
          <h1 style={styles.title}>SnelERP</h1>
          <p style={styles.subtitle}>Inicia sesión para continuar</p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div style={styles.error}>{error}</div>}
          <div style={styles.field}>
            <label style={styles.label}>Correo electrónico</label>
            <input
              style={styles.input}
              type="email"
              name="email"
              autoComplete="username"
              value={form.email}
              onChange={e => setForm({...form, email: e.target.value})}
              placeholder="admin@erp.com"
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Contraseña</label>
            <div style={{ position: 'relative' }}>
              <input
                style={{ ...styles.input, paddingRight: 44 }}
                type={showPw ? 'text' : 'password'}
                name="password"
                autoComplete="current-password"
                value={form.password}
                onChange={e => setForm({...form, password: e.target.value})}
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                onClick={() => setShowPw(v => !v)}
                style={styles.verBtn}
                tabIndex={-1}
                aria-label={showPw ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                title={showPw ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  {showPw ? (
                    <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>
                  ) : (
                    <><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></>
                  )}
                </svg>
              </button>
            </div>
          </div>
          <button style={{...styles.btn, opacity: loading ? 0.7 : 1}} type="submit" disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
        <p style={{ textAlign: 'center', color: '#64748b', fontSize: 13, marginTop: 16 }}>
          ¿Tu empresa es nueva? <Link to="/register" style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: 600 }}>Regístrala</Link>
        </p>
        <p style={{ textAlign: 'center', color: '#64748b', fontSize: 13, marginTop: 4 }}>
          ¿Eres contador? <Link to="/register-contador" style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: 600 }}>Crea tu cuenta</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#0f172a',
  },
  card: {
    background: '#1e293b', borderRadius: 16, padding: '40px 36px',
    width: '100%', maxWidth: 400, boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
  },
  header: { textAlign: 'center', marginBottom: 32 },
  logo: {
    display: 'inline-block', background: '#3b82f6', color: '#fff',
    borderRadius: 12, padding: '10px 18px', fontSize: 20, fontWeight: 700,
    letterSpacing: 2, marginBottom: 16,
  },
  title: { color: '#f1f5f9', fontSize: 22, fontWeight: 700, margin: '0 0 6px' },
  subtitle: { color: '#94a3b8', fontSize: 14, margin: 0 },
  field: { marginBottom: 18 },
  label: { display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 },
  input: {
    width: '100%', padding: '10px 14px', background: '#0f172a',
    border: '1px solid #334155', borderRadius: 8, color: '#f1f5f9',
    fontSize: 14, outline: 'none', boxSizing: 'border-box',
  },
  verBtn: {
    position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
    background: 'transparent', border: 'none', color: '#94a3b8',
    cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center',
  },
  btn: {
    width: '100%', padding: '12px', background: '#3b82f6', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600,
    cursor: 'pointer', marginTop: 8,
  },
  error: {
    background: '#450a0a', border: '1px solid #b91c1c', borderRadius: 8,
    color: '#fca5a5', padding: '10px 14px', marginBottom: 16, fontSize: 13,
  },
  footer: { textAlign: 'center', color: '#64748b', fontSize: 13, marginTop: 20 },
  link: { color: '#3b82f6', textDecoration: 'none' },
};
